// Direct fix for calculator cart quantity issues
document.addEventListener('DOMContentLoaded', function() {
  console.log("=== CALCULATOR CART FIX LOADED ===");
  
  // Constants
  const CALCULATOR_VARIANT_ID = "55795499139459";
  const CUSTOM_PRODUCT_HANDLE = "custom-charge-unit";
  
  // Function to directly update the cart table
  function updateCartTableQuantities() {
    console.log("Updating cart table quantities");
    
    // Find the cart table
    const cartTable = document.querySelector('table.data-table.full.cart-table');
    if (!cartTable) {
      console.log("Cart table not found");
      return;
    }
    
    // Get the cart data first
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        console.log("Cart data fetched:", cart);
        
        // Get all rows in the cart table
        const cartRows = cartTable.querySelectorAll('tbody tr');
        console.log("Cart rows found:", cartRows.length);
        
        // Create a map of line items for easy lookup
        const lineItemMap = {};
        cart.items.forEach(item => {
          lineItemMap[item.key] = item;
        });
        
        // Process each row
        cartRows.forEach(row => {
          // Skip if already processed
          if (row.hasAttribute('data-calculator-processed')) {
            return;
          }
          
          // Find the line item key for this row
          const qtyInput = row.querySelector('input[id^="updates_"]');
          if (!qtyInput) return;
          
          const keyMatch = qtyInput.name.match(/updates\[(.*?)\]/);
          if (!keyMatch || !keyMatch[1]) return;
          
          const lineKey = keyMatch[1];
          const item = lineItemMap[lineKey];
          
          if (!item) {
            console.log("No matching item found for key:", lineKey);
            return;
          }
          
          console.log("Processing row for item:", item.title);
          
          // Check if this is a calculator item
          if (item.variant_id.toString() === CALCULATOR_VARIANT_ID || 
              item.product_handle === CUSTOM_PRODUCT_HANDLE || 
              (item.properties && item.properties['_Product Title'] === 'Custom Cut Stove Glass')) {
            
            console.log("Found calculator item:", item);
            
            // Get the actual quantity from properties
            const actualQuantity = parseInt(item.properties.Quantity || 1);
            console.log("Actual quantity from properties:", actualQuantity);
            
            // Update the quantity input
            qtyInput.value = actualQuantity;
            
            // Create a hidden input with the same name to override the visible input
            const existingHiddenInput = row.querySelector(`input[type="hidden"][name="${qtyInput.name}"]`);
            if (!existingHiddenInput) {
              const hiddenInput = document.createElement('input');
              hiddenInput.type = 'hidden';
              hiddenInput.name = qtyInput.name;
              hiddenInput.value = actualQuantity;
              qtyInput.parentNode.appendChild(hiddenInput);
            }
            
            // Make the visible input read-only
            qtyInput.setAttribute('readonly', 'readonly');
            qtyInput.style.pointerEvents = 'none';
            
            // Disable the +/- buttons if they exist
            const minusButton = row.querySelector('.reduced.items');
            const plusButton = row.querySelector('.increase.items');
            
            if (minusButton) {
              minusButton.style.pointerEvents = 'none';
              minusButton.style.opacity = '0.5';
            }
            
            if (plusButton) {
              plusButton.style.pointerEvents = 'none';
              plusButton.style.opacity = '0.5';
            }
            
            // Update the product title to show quantity if > 1
            const titleElement = row.querySelector('h5.product-name');
            if (titleElement && actualQuantity > 1) {
              // Remove any existing quantity indicator
              let titleText = titleElement.textContent.replace(/\s*\(Qty: \d+\)/, '');
              titleText = `${titleText} (Qty: ${actualQuantity})`;
              titleElement.textContent = titleText;
            }
            
            // Mark this row as processed
            row.setAttribute('data-calculator-processed', 'true');
            row.setAttribute('data-actual-quantity', actualQuantity);
          }
        });
      })
      .catch(error => console.error("Error fetching cart:", error));
  }
  
  // Function to update mini-cart quantities
  function updateMiniCartQuantities() {
    console.log("Updating mini-cart quantities");
    
    // Check if we're on the checkout page
    if (window.location.pathname.includes('/checkout')) {
      console.log("On checkout page, skipping mini-cart update");
      return;
    }
    
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        // Calculate real item count
        let realItemCount = 0;
        
        cart.items.forEach(item => {
          if (item.variant_id.toString() === CALCULATOR_VARIANT_ID || 
              item.product_handle === CUSTOM_PRODUCT_HANDLE || 
              (item.properties && item.properties['_Product Title'])) {
            realItemCount += parseInt(item.properties.Quantity || 1);
          } else {
            realItemCount += item.quantity;
          }
        });
        
        console.log("Real item count:", realItemCount);
        
        // Update all mini-cart quantity displays
        const miniCartQuantities = document.querySelectorAll('.mini-cart .cart-qty, .header-cart .cart-qty, .cart-count, .mini-cart-count, [class*="cart-count"], [class*="cart-qty"]');
        miniCartQuantities.forEach(el => {
          // Only update if the value is different to avoid unnecessary DOM updates
          if (el.textContent !== realItemCount.toString()) {
            el.textContent = realItemCount;
          }
        });
        
        // Update cart total displays
        const cartTotals = document.querySelectorAll('.cart-total-items, .total-items');
        cartTotals.forEach(total => {
          if (total.textContent.includes('item')) {
            const newText = `${realItemCount} item${realItemCount !== 1 ? 's' : ''}`;
            if (total.textContent !== newText) {
              total.textContent = newText;
            }
          }
        });
        
        // Update mini-cart items
        const miniCartItems = document.querySelectorAll('.cart-wrapper .item-cart, .widget-shopping-cart .item-cart');
        
        // Create a map of cart items by variant ID for faster lookup
        const cartItemsByVariant = {};
        cart.items.forEach(item => {
          if (!cartItemsByVariant[item.variant_id]) {
            cartItemsByVariant[item.variant_id] = [];
          }
          cartItemsByVariant[item.variant_id].push(item);
        });
        
        miniCartItems.forEach(cartItem => {
          // Skip if this item has already been processed
          if (cartItem.hasAttribute('data-calculator-processed')) {
            return;
          }
          
          // Try to find the variant ID from the cart item HTML
          const variantIdMatch = cartItem.innerHTML.match(/variant=(\d+)/);
          if (!variantIdMatch) return;
          
          const variantId = variantIdMatch[1];
          
          // Find the matching cart item
          if (!cartItemsByVariant[variantId] || cartItemsByVariant[variantId].length === 0) return;
          
          const item = cartItemsByVariant[variantId][0];
          
          // Check if this is a calculator item
          if (item.variant_id.toString() === CALCULATOR_VARIANT_ID || 
              item.product_handle === CUSTOM_PRODUCT_HANDLE || 
              (item.properties && item.properties['_Product Title'])) {
            
            const actualQuantity = parseInt(item.properties.Quantity || 1);
            
            // Update the price display
            const priceElement = cartItem.querySelector('.price');
            if (priceElement) {
              const formattedPrice = new Intl.NumberFormat('en-GB', {
                style: 'currency',
                currency: 'GBP'
              }).format(item.line_price / 100);
              
              priceElement.innerHTML = `${actualQuantity} \D7 <span class="amount"><span class="money">${formattedPrice}</span></span>`;
            }
            
            // Update the title
            const titleElement = cartItem.querySelector('.product-name');
            if (titleElement && actualQuantity > 1) {
              let titleText = titleElement.textContent.replace(/\s*\(Qty: \d+\)/, '');
              titleText = `${titleText} (Qty: ${actualQuantity})`;
              titleElement.textContent = titleText;
            }
            
            // Mark as processed
            cartItem.setAttribute('data-calculator-processed', 'true');
          }
        });
      })
      .catch(error => console.error("Error updating mini-cart:", error));
  }
  
  // Flag to prevent multiple simultaneous updates
  let isUpdating = false;
  let updateCount = 0;
  const MAX_UPDATES = 5; // Maximum number of updates to perform
  
  // Function to safely run updates
  function safeRunUpdates() {
    if (isUpdating) return;
    
    // Check if we've reached the maximum number of updates
    if (updateCount >= MAX_UPDATES) {
      console.log(`Maximum updates (${MAX_UPDATES}) reached, stopping automatic updates`);
      return;
    }
    
    isUpdating = true;
    updateCount++;
    
    console.log(`Running update ${updateCount}/${MAX_UPDATES}`);
    
    updateCartTableQuantities();
    updateMiniCartQuantities();
    
    // Reset the flag after a delay
    setTimeout(() => {
      isUpdating = false;
    }, 2000);
  }
  
  // Reset update count when the page is interacted with
  document.addEventListener('click', function() {
    updateCount = 0;
  });
  
  // Run on page load
  setTimeout(safeRunUpdates, 1000);
  
  // Run when cart is updated
  document.addEventListener('cart:updated', function() {
    // Reset update count for explicit cart updates
    updateCount = 0;
    setTimeout(safeRunUpdates, 500);
  });
  
  // Use a heavily debounced version of the observer to prevent too many updates
  let observerTimeout;
  const observer = new MutationObserver(function(mutations) {
    // Clear any existing timeout
    if (observerTimeout) {
      clearTimeout(observerTimeout);
    }
    
    // Set a new timeout with a longer delay
    observerTimeout = setTimeout(() => {
      let shouldUpdate = false;
      
      for (const mutation of mutations) {
        if (mutation.target.closest('.cart-table, #cart, .cart-form, .mini-cart, .header-cart')) {
          shouldUpdate = true;
          break;
        }
      }
      
      if (shouldUpdate && updateCount < MAX_UPDATES) {
        safeRunUpdates();
      }
    }, 1000);
  });
  
  // Start observing
  const cartContainers = document.querySelectorAll('.cart-table, #cart, .cart-form, .mini-cart, .header-cart');
  cartContainers.forEach(container => {
    if (container) {
      observer.observe(container, {
        childList: true,
        subtree: true
      });
    }
  });
});